<template>
  <!-- <video :src="videoSrc" :style="{width:width+'px',heigth:heigth+'px'}"></video> -->
  <!-- <video
    src="https://www.w3schools.com/html/mov_bbb.mp4"
    controls
    width="160"
    height="90"
  ></video> -->
  <div class="video-container">
    <div class="video-poster-container" @click="haddleShowVideo">
      <img class="video-poster-img" :src="videoPosterSrc" alt="" />
      <img src="@/assets/img/video_playr.png" class="video-poster-btn" alt="" />
    </div>

    <el-dialog :visible.sync="isShowVideo" append-to-body :close-on-click-modal="false" class="video-container-dialog"
      custom-class="video-custom-dialog">
      <div class="video-content" v-if="isShowVideo">
        <img src="@/assets/img/close.png" class="video-close-img" @click="haddleCloseVideo" />
        <video-player :options="playerOptions"></video-player>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css"; // 引入 video.js 样式文件
import { getQuestionVideoAudioUrl } from "@/http/index";
export default {
  components: { videoPlayer },
  props: {
    videoPosterSrc: {
      type: String,
      default: "",
    },
    videoSrc: {
      type: String,
      default: "",
    },
    vid: "",
  },
  data() {
    return {
      isShowVideo: false,
      playerOptions: {
        autoplay: true, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        language: "zh-CN",
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: {
          type: "video/mp4", // 类型
          src: this.videoSrc, // url地址
          // src: "https://www.w3schools.com/html/mov_bbb.mp4", // url地址
        },

        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controls: true, // 显示控制条
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
    };
  },
  watch: {
    videoSrc: {
      handler(newSrc, oldSrc) {
        this.playerOptions.sources.src = newSrc;
      },
      deep: true,
    },
  },
  methods: {
    async haddleShowVideo() {
      if (!this.videoSrc) {
        if (this.loading) return;
        this.loading = true;
        const res = await getQuestionVideoAudioUrl({
          token: localStorage.getItem("token"),
          secret: localStorage.getItem("secret"),
          hospital_id: localStorage.getItem("hospital_id"),
          type: 1,
          vid: this.vid,
          get_type: 1,
        });
        this.playerOptions.sources.src = res.data.playInfo.playurl;
        this.loading = false;
      }
      this.isShowVideo = true;
      this.$store.commit("SET_VIDEO_PLAYING", true);
    },
    haddleCloseVideo() {
      this.isShowVideo = false;
      this.$store.commit("SET_VIDEO_PLAYING", false);
    },
  },
};
</script>

<style scoped lang="scss">
.video-container {
  margin-right: 10px;

  .video-poster-container {
    width: 160px;
    height: 90px;
    position: relative;
    border-radius: 12px;

    .video-poster-img {
      width: 100%;
      height: 100%;
      border-radius: 12px;
    }

    .video-poster-btn {
      width: 26px;
      height: 26px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
    }
  }

  &-dialog {
    ::v-deep .video-custom-dialog {
      background-color: transparent !important;
      box-shadow: none !important;
      border: none !important;

      .el-dialog__header {
        display: none;
      }

      .el-dialog__body {
        display: flex;
        justify-content: center;
      }

      .video-content {
        position: relative;
        width: 640px;

        .video-close-img {
          width: 20px;
          height: 20px;
          position: absolute;
          left: 10px;
          top: 10px;
          z-index: 1;
          cursor: pointer;
        }

        .video-player {
          max-width: 640px;
          .vjs-big-play-button{
            display: none;
          }
          .vjs-control-bar{
            .vjs-volume-panel-horizontal{
              display: none;
            }
          }
        }
      }
    }

    // ::v-deep .el-dialog__body {
    //   // height: 0;
    //   // padding: 0;
    //   .video-player {
    //     max-width: 640px;
    //   }
    // }
  }
}
</style>